export default __webpack_public_path__ + "static/media/ban1.ee1eb2ea.png";